import React, { FC } from "react";
import { Descriptions } from "antd";
import moment from "moment";
import "./stakeInfo.scss";
import { convertFromWeiFormatted } from "../../utils/number";
import { IAllStakeingData } from "../../types/Staking";

export const AllStakeInfoTable: FC<IAllStakeingData> = ({
  id_,
  timeToUnlock,
  stakingTime,
  tokensStaked,
  tokensStakedWithBonus,
  chain,
}) => {
  return (
    <>
      <div className="table-size">
        <Descriptions
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 2 }}
          bordered
        >
          <Descriptions.Item label="Id">{id_}</Descriptions.Item>
          <Descriptions.Item label="Staking Time">
            {moment.unix(Number(stakingTime)).format("MM/DD/yyyy hh:mm A")}
          </Descriptions.Item>
          <Descriptions.Item label="Tokens Staked">
            {convertFromWeiFormatted(tokensStaked)}
          </Descriptions.Item>
          <Descriptions.Item label="Lock Time">
            {timeToUnlock &&
              `${moment({})
                .seconds(+timeToUnlock)
                .format("M")} months`}
          </Descriptions.Item>
          <Descriptions.Item label="Tokens Staked with Bonus">
            {convertFromWeiFormatted(+tokensStakedWithBonus)}
          </Descriptions.Item>
          <Descriptions.Item label="Chain">{chain}</Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};
